// @flow
import React from "react";
import CountUp from "react-countup";
import I18n from "../../../i18n/I18n";
import { LocaleLink } from "../../common/";
import styles from "./OrderStatusSummary.scss";

const OrderStatusSummary = (props: Object) => {
  const { data } = props;
  const { counts } = data;
  return (
    <div className={styles.summaryCtr}>
      <LocaleLink to={`/orders?status=1`} className={styles.summaryItem}>
        <h3 className={styles.summaryTitle}>
          {I18n.getText("dashboard.new-orders")}
        </h3>
        <div className={styles.count}>
          <CountUp start={0} end={Number(counts.new)} />
        </div>
      </LocaleLink>

      <LocaleLink to={`/orders?status=2`} className={styles.summaryItem}>
        <h3 className={styles.summaryTitle}>
          {I18n.getText("dashboard.accepted-orders")}
        </h3>
        <div className={styles.count}>
          <CountUp start={0} end={Number(counts.accepted)} />
        </div>
      </LocaleLink>

      <LocaleLink to={`/orders?status=3`} className={styles.summaryItem}>
        <h3 className={styles.summaryTitle}>
          {I18n.getText("orders.ready-for-pickup")}
        </h3>
        <div className={styles.count}>
          <CountUp start={0} end={Number(counts.readyforpickup)} />
        </div>
      </LocaleLink>

      <LocaleLink to={`/orders?status=4`} className={styles.summaryItem}>
        <h3 className={styles.summaryTitle}>
          {I18n.getText("dashboard.picked-items")}
        </h3>
        <div className={styles.count}>
          <CountUp start={0} end={Number(counts.picked)} />
        </div>
      </LocaleLink>
    </div>
  );
};

export default OrderStatusSummary;



// WEBPACK FOOTER //
// ./src/components/dashboard/OrderStatusSummary/OrderStatusSummary.js